import styled from "styled-components";

import { BaseCell, TextAnchor } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

export const StyledIconContainer = styled.div`
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[0]};
    border: 1px solid ${colorsPalettes.carbon[50]};
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledBaseCell = styled(BaseCell)`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const StyledTextAnchor = styled(TextAnchor)`
    display: block;
    max-width: 100%;
    overflow: hidden;
`;
